import React, { useEffect, useState } from 'react'
import { TextAreaProps as AntTextAreaProps } from 'antd/lib/input/TextArea'
import { Input as AntInput } from 'antd'
import './styles.css'

const AntTextArea = AntInput.TextArea

interface TextAreaProps extends AntTextAreaProps {
  maxLength?: number | undefined
  edit?: boolean
  minRows?: number | undefined
  maxRows?: number | undefined
}

const TextArea = (props: TextAreaProps) => {
  const {
    maxLength,
    edit = true,
    rows,
    minRows = rows || 2,
    maxRows = rows || 5,
    children,
    ...rest
  } = props

  const [className, setClassName] = useState<string>()

  useEffect(() => {
    if (!edit) {
      setClassName('')
    }
  }, [edit])

  const handleFormatter = (args: { count: number }) => {
    if (maxLength) setClassName(args.count > maxLength ? 'text-area-over' : '')
    return `${args.count}/${maxLength}`
  }

  const showCountProp =
    maxLength && edit ? { formatter: handleFormatter } : false

  return (
    <AntTextArea
      className={className}
      showCount={showCountProp}
      autoSize={{ minRows, maxRows }}
      {...rest}>
      {children}
    </AntTextArea>
  )
}

export default TextArea
export type { TextAreaProps }
